module.exports = __webpack_public_path__ + "static/media/styledSchedule.b877463e.svg";